import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {IconButton, InputAdornment, TextField} from '@mui/material';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import EditIcon from '@mui/icons-material/Edit';
import SelectNonPSLJustificationPopup from '../../dialogs/SelectNonPSLJustificationPopup.jsx';
import {SOURCES} from '../../../utils/constants.js';
import {BrickContext} from 'olympe';
import {useFieldEditability} from '../utils/useFieldEditability.js';

/**
 * @param {InternalComments.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function InternalComments(props) {
    const useRequestStore = requestStores.get(props.prTag);
    const [internalComment, setInternalComment] = useRequestStore((state) => [state.internalComment, state.setInternalComment]);
    const source = useRequestStore((state) => state.source);
    const projectTitle = useRequestStore((state) => state.projectTitle);
    const showCBJustification = useRequestStore((state) => state.showCBJustification);
    const updateInternalComment = useRequestStore((state) => state.updateInternalComment);
    const [nonPslJustification, setNonPslJustification] = useRequestStore((state) => [state.nonPslJustification, state.setNonPslJustification]);
    const {isDisabled} = useFieldEditability(props.prTag, {context: props.context});
    const indexOfFirst = internalComment.indexOf('---');
    const indexOfSecond = internalComment.indexOf('---', indexOfFirst + 1);
    const indexOfProjectSeparator = internalComment.indexOf('\n\n', indexOfSecond + 1);

    // Here we create a string from the internal comment, removing the "---"
    const automatedPart = internalComment.substring(0, indexOfFirst) + internalComment.substring(indexOfFirst + 3, indexOfSecond - 1);
    const [freeTextPart, setFreeTextPart] = useState(indexOfProjectSeparator > 0 ? internalComment.substring(indexOfProjectSeparator + 2) : internalComment.substring(indexOfSecond + 4)); // + 4 because there are --- and a \n

    const [sentProjectTitle, setSentProjectTitle] = useState(`Project/Order title: ${projectTitle||''} \n\n`);

    const [showSelectNonPslJustificationPopup, setShowSelectNonPslJustificationPopup] = useState(false);
    useEffect(()=>{
        setSentProjectTitle(`Project/Order title: ${projectTitle||''} \n\n`);
        setInternalComment(internalComment.substring(0, indexOfSecond + 3) + '\n' + `Project/Order title: ${projectTitle||''} \n\n` + freeTextPart);
    }, [projectTitle]);

    useEffect(() => {
        updateInternalComment();
    }, []);

    const handleModifyFreeText = (event) => {
        const newText = event.target.value;
        setFreeTextPart(newText);
        setInternalComment(internalComment.substring(0, indexOfSecond + 3) + '\n' + sentProjectTitle + newText);
    };

    return (
        <div className={'pr-editor-centered-submodule'}>
            <div className={'pr-editor-comments'}>
                <TextField
                    fullWidth
                    id="outlined-multiline-internal-comments-automated"
                    label="Comments (internal only)"
                    multiline
                    rows={6}
                    focused
                    disabled
                    inputRef={(input) => {
                        // update the value of the textfield, when it is updated asynchronously after first render
                        if (input !== null) {
                            input.value = automatedPart;
                        }
                    }}
                />
                <TextField
                    fullWidth
                    id="outlined-multiline-internal-comments-project-title"
                    focused
                    disabled
                    inputRef={(input) => {
                        // update the value of the textfield, when it is updated asynchronously after first render
                        if (input !== null) {
                            input.value = sentProjectTitle;
                        }
                    }}
                />
                {(source !== SOURCES.PSL && nonPslJustification !== '') && (
                    <TextField
                        fullWidth
                        id="outlined-multiline-internal-comments-nonpsl-justification"
                        focused
                        disabled
                        inputRef={(input) => {
                        // update the value of the textfield, when it is updated asynchronously after first render
                            if (input !== null) {
                                input.value = nonPslJustification;
                            }
                        }}
                        InputProps = {{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={()=>{
                                        setShowSelectNonPslJustificationPopup(true);
                                    }}>
                                        <EditIcon />
                                    </IconButton>
                                </InputAdornment>),
                        }}
                    />)}
                <TextField
                    fullWidth
                    id="outlined-multiline-internal-comments-free-text"
                    multiline
                    rows={4}
                    inputRef={(input) => {
                        // update the value of the textfield, when it is updated asynchronously after first render
                        if (input !== null) {
                            input.value = freeTextPart;
                        }
                    }}
                    onBlur={handleModifyFreeText}
                    disabled={isDisabled('attachments.internalComments')}
                />
                {showCBJustification &&
                    <div className={'pr-editor-attachments-cb-text'}>
                        A competitive bidding is required. Make sure the justifications are provided (with comments if needed) in the “Attachments & Comments” section.
                    </div>
                }
                {showSelectNonPslJustificationPopup && (
                    <SelectNonPSLJustificationPopup nonPslJustification={nonPslJustification} setNonPslJustification={setNonPslJustification} handleOnClose={()=>{
                        setShowSelectNonPslJustificationPopup(false);
                    }} />
                )}
            </div>
        </div>
    );
}

InternalComments.propTypes = {
    prTag: PropTypes.string,
    context: PropTypes.instanceOf(BrickContext).isRequired,
};
